var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1172.966,31.906h-2.979a.992.992,0,0,1,0-1.984h2.979a.992.992,0,1,1,0,1.984Z",
    transform: "translate(-1159.905 -10.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.966,38.7h-2.979a.992.992,0,0,1,0-1.984h2.979a.992.992,0,1,1,0,1.984Z",
    transform: "translate(-1159.905 -8.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.439,31.906h-2.979a.992.992,0,1,1,0-1.984h2.979a.992.992,0,0,1,0,1.984Z",
    transform: "translate(-1158.139 -10.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.439,38.7h-2.979a.992.992,0,1,1,0-1.984h2.979a.992.992,0,0,1,0,1.984Z",
    transform: "translate(-1158.139 -8.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.811,25.111H1169.5a.992.992,0,1,1,0-1.984h19.31a.992.992,0,1,1,0,1.984Z",
    transform: "translate(-1160.062 -12.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.914,31.906h-2.979a.992.992,0,0,1,0-1.984h2.979a.992.992,0,1,1,0,1.984Z",
    transform: "translate(-1156.371 -10.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.914,38.7h-2.979a.992.992,0,0,1,0-1.984h2.979a.992.992,0,1,1,0,1.984Z",
    transform: "translate(-1156.371 -8.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.313,58.235h-38.189V15.219h38.189Zm-36.205-1.984h34.221V17.2h-34.221Z",
    transform: "translate(-1162.123 -15.219)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleBilling);
export default __webpack_public_path__ + "static/media/icon_module_billing.25c151468c6a5a14cfc8fd66a680b66e.svg";
export { ForwardRef as ReactComponent };